"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DetailMainSection = exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _constants = require("../../constants");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  &&:last-child {\n    margin-bottom: -", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding: ", "px ", "px;\n  background-color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var getBackgroundColor = function getBackgroundColor(color) {
  switch (color) {
    case 'light':
      return _colors.GYPSUM;

    case 'dark':
      return _colors.OBSIDIAN;

    default:
      return _colors.OLAF;
  }
};

var MainSection = _styledComponents.default.div.withConfig({
  displayName: "MainSection",
  componentId: "sc-11xcqrp-0"
})(_templateObject(), _constants.MAIN_SECTION_PADDING_Y, _constants.MAIN_SECTION_PADDING_X, function (props) {
  return getBackgroundColor(props.color);
});

MainSection.propTypes = {
  color: _propTypes.default.string
};
var _default = MainSection;
exports.default = _default;
var DetailMainSection = (0, _styledComponents.default)(MainSection).withConfig({
  displayName: "MainSection__DetailMainSection",
  componentId: "sc-11xcqrp-1"
})(_templateObject2(), _sizes.LAYOUT_PADDING_X);
exports.DetailMainSection = DetailMainSection;


//////////////////
// WEBPACK FOOTER
// ./js/components/layout/MainSection.js
// module id = 201
// module chunks = 209 210 211 212